

<div class="{{getDirection()=='rtl'?'base-rtl':'base-ltr'}}">

  <div class="doc-main-div">
    <div class="doc-top-div">
      <div class="docs-right">
        <div style="padding: 0px 13px;">
          <i class=" toggel-sidbar pi pi-bars {{menuStat=='open'?'active':''}}" (click)="toggelSidbar()"></i>
        </div>
        <div class="doc-menu" *ngFor="let doc of listDocs">
          <div style="width: 100% ;">
            <i (click)="selectDoc(doc)"
               style="{{selectedDoc.id==doc.id?'color:#4c0bfb;text-shadow: 0px 0px 1px #060200;width: 100%':'width: 100%'}} ">{{doc.label}}</i>
          </div>
        </div>
      </div>
      <div style="text-align: left"><i i18n-pTooltip="@@Search" pTooltip="Search"
                                       style=" padding-top: 11px;font-size: 25px; font-weight: bold;color: #4c0bfb;width: 30px; margin-left: 12px;margin-right: 12px;cursor: pointer"
                                       (click)="openSearchBox()" class="pi pi-search"></i></div>
      <div *ngIf="global.getCluster() != 'germany' && locale=='en'"
           style="{{'background-image: url('+config.getBaseUrl()+'doc/file/get_image?name=logoEN1.svg)' }}"
           class="docs-logo " >
      </div>
      <div *ngIf="global.getCluster() != 'germany' && locale=='fa'"
           style="{{'background-image: url('+config.getBaseUrl()+'doc/file/get_image?name=logo1.png)' }}"
           class="docs-logo " >
      </div>
      <div *ngIf="global.getCluster() == 'germany'"
           style="{{'background-image: url('+config.getBaseUrl()+'doc/file/get_image?name=logo_de.png)' }}"
           class="docs-logo">

      </div>

    </div>
    <div class="doc-center-div">
      <div class="doc-right-div {{menuStat=='open'?'':'menu_close'}} ">
        <div class="category-tree">
          <p-tree [value]="categoryTree" emptyMessage=" " [style.height]="'100%'" selectionMode="single" [(selection)]="selectedTree"
                  (onNodeSelect)="nodePageSelect($event)"></p-tree>
        </div>
      </div>
      <div class="doc-left-div {{menuStat=='open'?'':'menu_close'}}">
        <p-progressBar   mode="indeterminate"  *ngIf="global.progressBar"
                         [style]="{'height': '6px','position': 'fixed','width': '100%','border-radius':'0px'}"></p-progressBar>
        <div class=" post-main-div">
          <div class="page-navigation select-none">
            <div>{{selectedDoc.label | uppercase}}</div>
            <div *ngFor="let cat of creatNavCategoryList()">
              <i class="pi {{getDirection()=='rtl'?'pi-angle-left':'pi-angle-right'}}"></i>
              {{cat.name | uppercase}}
            </div>
            <div>
              <i class="pi {{getDirection()=='rtl'?'pi-angle-left':'pi-angle-right'}}"></i>
              {{selectedPage.label | uppercase}}
            </div>

          </div>
          <div class="select-none"  style="color: #b5b2b2;"
               *ngIf="selectedPage && selectedPage.id>0 && loadPageComplete">
            <div style="position: relative;font-size: 12px;padding: 0px 7px;" class="pi pi-clock"></div>
            <span
              *ngIf="getDirection()=='rtl'">{{miliSecontToDate(selectedPage.lastUpdate) | dateText : "yyyy/mm/dd" | numberText }} </span>
            <span
              *ngIf="getDirection()=='ltr'">{{miliSecontToDate(selectedPage.lastUpdate) | dateText : "dd D-M-yyyy"  }} </span>
          </div>
          <div class="grid">
            <div class="col-12 md:col-9">
              <div *ngFor="let post of selectedPage.publish_posts ; let j = index" class="grid post-div">
                <div (click)="copyToClipboard(getHost()+'/'+locale+'/docs/gotopage/'+selectedPage.uid+'/'+post.uid)"
                     class=" hashtag col-9 post-title" id="{{creatPostTag(post)}}">
                  <h2 style="cursor: pointer" i18n-pTooltip="@@Link Copy" pTooltip="Link Copy" >{{post.label}}</h2> <a
                  href="{{creatPostTagLink(post)}}">#</a></div>
                <div *ngFor="let item of post.postItems ; let i = index"
                     class=" {{item.itemAttribute.widthClass ?item.itemAttribute.widthClass:'col-12' }} post-item"
                     id="{{j+''+i}}">
                  <!--            <div [innerHTML]="item.html_not_publish | safeHtml"></div>-->
                  <div [innerHTML]="showItemInPost(post,item) | safeHtml"></div>
                </div>
              </div>
<!--              &lt;!&ndash;            <div *ngFor="let post of selectedPage.posts ; let j = index" class=" grid post-div">&ndash;&gt;-->
<!--              &lt;!&ndash;              <div class=" hashtag col-12 post-title" id="{{creatPostTag(post)}}"><h2>{{post.label}}</h2> <a&ndash;&gt;-->
<!--              &lt;!&ndash;                href="{{creatPostTagLink(post)}}">#</a></div>&ndash;&gt;-->
<!--              &lt;!&ndash;              <div *ngFor="let item of post.postItems ; let i = index"&ndash;&gt;-->
<!--              &lt;!&ndash;                   class=" {{item.itemAttribute.widthClass ?item.itemAttribute.widthClass:'col-12' }} post-item"&ndash;&gt;-->
<!--              &lt;!&ndash;                   id="{{j+''+i}}">&ndash;&gt;-->
<!--              &lt;!&ndash;                <div [innerHTML]="item.html_code | safeHtml"></div>&ndash;&gt;-->
<!--              &lt;!&ndash;              </div>&ndash;&gt;-->
<!--              &lt;!&ndash;            </div>&ndash;&gt;-->
            </div>



            <div class="postList hidden md:block col-12 md:col-3 ">
              <ul>
                <div class="on-this-page" i18n="@@Titles of this page">Titles of this page</div>
                <li *ngFor="let p of postMenu  " id="list_{{p.value}}" data-value="{{p.top}}" [attr.aria-label]="p.top2" class="postlist-li"
                    (click)="goToFregment(p.value);"><a href="{{getPostLink(p.value)}}"></a>{{p.label}}</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="search-div" [hidden]="!showSearchPnl">
    <div class="pnl">
      <div class="search-box-pnl ">

        <div style="width: calc(100% - 50px);padding-right: 20px;display: flex">
          <input id="inputSearch" #searchInp pInputText [(ngModel)]="searchQuery" i18n-placeholder="@@Search"
                 placeholder="Search" (keyup)="searchOnIndex($event,null)"
                 (keyup)="keyUpDown($event)" autocomplete="off">
          <i *ngIf="searchQuery.length>0" (click)="searchQuery=''" style="color:red;margin-top: 21px;margin-left: 10px;"
             class="pi pi-times"></i>
        </div>
        <div
          style="width: 50px;cursor: pointer;margin-left: 5px;padding-top: 20px;{{getDirection()=='rtl' ? 'border-right: 1px solid #8d918f;':'border-left: 1px solid #8d918f'}}"
          (click)="showSearchPnl=false" i18n="@@Cancel">Cancel
        </div>
      </div>
      <div *ngIf="searchRes.length>0" style="box-shadow: 0px 1px 2px #a2a2a2;width: 100%;height: 1px;"></div>
      <div class="search-res-pnl">
        <div #sres class="searchres"
             *ngFor="let res of searchRes;let i=index">

          <div class="col-12">
            <div class="dataview-res" (click)="gotoPage(res,i)">
              <div style="font-weight: bold;height: 30px"
                   [innerHTML]="getSearchResValue(res, 'postLabel')['val']"></div>
              <div style="display: flex">
                <div *ngIf="getSearchResValue(res, 'docLabel')['val']!= null" style="display: flex">
                  <div
                    [innerHTML]="getSearchResValue(res, 'docLabel')!= null ? getSearchResValue(res, 'docLabel')['val'] :''"></div>
                  <i *ngIf="getDirection()=='rtl'" style="margin-left: 10px; margin-right: 10px;margin-top: 1px;"
                     class=" pi pi-chevron-left"></i>
                  <i *ngIf="getDirection()=='ltr'" style="margin-left: 10px; margin-right: 10px;margin-top: 1px;"
                     class=" pi pi-chevron-right"></i>
                </div>

                <div *ngIf="getSearchResValue(res, 'categoryName')['val']!= null" style="display: flex">
                  <div
                    [innerHTML]="getSearchResValue(res, 'categoryName') != null ?getSearchResValue(res, 'categoryName')['val']:''"></div>
                  <i *ngIf="getDirection()=='rtl'" style="margin-left: 10px; margin-right: 10px;margin-top: 1px;"
                     class=" pi pi-chevron-left"></i>
                  <i *ngIf="getDirection()=='ltr'" style="margin-left: 10px; margin-right: 10px;margin-top: 1px;"
                     class=" pi pi-chevron-right"></i>
                </div>

                <div>
                  <span [innerHTML]="getSearchResValue(res, 'pageLabel')['val']"></span>
                  <!--                  <i style="margin-left: 10px;margin-right: 10px;" class=" pi pi-caret-left"></i>-->
                </div>

              </div>

            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</div>
